export default {
  "content": "<path d=\"M2.14 7.3v-.2c-.01-2.48 1.9-4.6 4.26-4.6 1.6 0 3.07.95 3.8 2.45.32-.14.66-.21 1-.21 1.35 0 2.46 1.19 2.63 2.56 1.26.45 2.17 1.72 2.17 3.2 0 1.86-1.43 3-3.2 3H3.2c-1.77 0-3.2-1.14-3.2-3 0-1.47.9-2.74 2.14-3.2z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};